<template>
  <div>
    <el-card>
      <el-row>
        <el-col :span="24 / worksData.length" v-for="(dataItem, key) in worksData" :key="key">
          <p class="title">{{ $t(dataItem.title) }}</p>
          <p class="count">
            <strong>{{ dataItem.count }}</strong>
          </p>
        </el-col>
      </el-row>
    </el-card>

    <el-row :gutter="20" class="data-charts">
      <el-col :span="12">
        <upload-data-chart></upload-data-chart>
      </el-col>

      <el-col :span="12">
        <track-data-chart></track-data-chart>
      </el-col>
    </el-row>

    <cp-data-chart class="data-charts" v-if="!hiddenCpData"></cp-data-chart>
  </div>
</template>

<script>
import UploadDataChart from './components/UploadDataChart.vue'
import TrackDataChart from './components/TrackDataChart.vue'
import CpDataChart from './components/CpDataChart.vue'
import TWEEN from '@tweenjs/tween.js'
import dataService from '@/api/data'
import { mapGetters } from 'vuex'
import { ROLE_TYPE_ENUM } from '@/views/person/const'

export default {
  name: 'Perform',

  components: {
    UploadDataChart,
    TrackDataChart,
    CpDataChart
  },
  data() {
    return {
      count: {
        albumTotal: 0,
        singerTotal: 0,
        trackTotal: 0,
        videoTotal: 0
      },
    }
  },

  computed: {
    ...mapGetters([
      'userInfo',
      'company',
    ]),

    // Merlin: 101433, Believe: 3997隐藏版权数据
    hiddenCpData() {
      return this.company && (this.company.companyId === 101433 || this.company.companyId === 3997)
    },

    worksData() {
      const data = [
        {
          title: 'data.perform.track',
          count: this.count.trackTotal,
          isShow: true
        },
        {
          title: 'data.perform.album',
          count: this.count.albumTotal,
          isShow: true
        },
        {
          title: 'data.perform.mv',
          count: this.count.videoTotal,
          isShow: true
        },
        {
          title: 'data.perform.singer',
          count: this.count.singerTotal,
          isShow: true
        },
      ]

      return data.filter(item => item.isShow)
    },
  },

  mounted() {
    this.fetchCount()
  },

  methods: {
    async fetchCount() {
      try {
        const data = await dataService.queryTotalData()
        this.setCountData(data)
      } catch (e) {
        this.$message.error(e.message)
      }
    },
    setCountData(data) {
      function animate() {
        if (TWEEN.update()) {
          requestAnimationFrame(animate)
        }
      }
      const tween = new TWEEN.Tween(this.count)
      tween.to(data, 500)
      tween.onUpdate(({ albumTotal, singerTotal, trackTotal, videoTotal }) => {
        this.count.albumTotal = albumTotal.toFixed(0)
        this.count.singerTotal = singerTotal.toFixed(0)
        this.count.trackTotal = trackTotal.toFixed(0)
        this.count.videoTotal = videoTotal.toFixed(0)
      })
      tween.start()

      animate()
    }
  }
}
</script>

<style lang="scss" scoped>
.data-charts {
  margin-top: 20px;
}

.title {
  height: 25px;
  font-size: 18px;
  line-height: 25px;
  color: rgba(0, 36, 68, 1);
  color: #002444;
}

.count {
  margin-top: 5px;
  font-size: 18px;
  color: #002444;
  strong {
    height: 40px;
    font-size: 28px;
    font-weight: 600;
    line-height: 40px;
  }
}
</style>
